<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">
            Hoy
          </v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on:click="on.click">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Día</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 días</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">

        <v-row class="mb-2">

  <v-col cols="6">
    <v-btn
      color="primary"
      @click="guardar"
    >
      <v-icon left>mdi-file-plus</v-icon>
      Agregar Documento
    </v-btn>
  </v-col>

</v-row>


        <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :event-color="getEventColor"
          :event-text-color="getEventTextColor" :event-margin-bottom="3" :now="today" :type="type"
          @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]" locale="es" :short-weekdays="false"></v-calendar>
        <v-dialog v-model="selectedOpen" max-width="800px">
          <v-card color="grey lighten-4" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title v-html="selectedEvent.name" style="color: black;"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form v-if="currentlyEditing !== selectedEvent.id" :style="{ color: 'black' }">

                <v-row>
                  <ul>
                    <li v-for="documento in documentos" :key="documento.id">
                      {{ documento.documentonombre }}
                    </li>
                  </ul>


                </v-row>

                <div align="center" justify="center" v-if="eventoestatus == 1">
                  <div class="my-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="guardar(selectedEvent)"
                          v-bind="attrs" v-on="on">
                          <v-icon dark>
                            mdi-content-save
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Guardar documento</span>
                    </v-tooltip>
                  </div>
                </div>

                <div align="center" justify="center" v-if="eventoestatus == 2">
                  <div class="my-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="ver(selectedEvent)" v-bind="attrs"
                          v-on="on">
                          <v-icon dark>
                            mdi-text-box-search
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Ver documento</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-form>


            </v-card-text>

            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="modaldocumento" max-width="1200" :hide-overlay="$vuetify.breakpoint.xsOnly"
          transition="dialog-bottom-transition">
          <v-card>
            <v-alert shaped dark color="primary">
              Datos de Documento
            </v-alert>

            <v-card-text>
              <v-container fluid class="pa-0" style="max-width: 1000px;"> <v-row justify="center">


                  <v-form style="width: 100%;">
                    <v-container fluid grid-list-sm class="pa-4 white">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-alert type="success" class="subtitle-2 text-center" color="primary">
                            ALTA DE DOCUMENTOS: {{ eventodetallenombre }}
                          </v-alert>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" class="py-0">
                          <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                            v-on:change="selectempresanombre()" outlined></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechacarga" label="Fecha de Recepcion"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0">
                          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documentofechavence" label="Fecha del Vencimiento"
                                prepend-icon="event" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="documentofechavence" @input="menu1 = false"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="12">
                          <v-textarea v-model="documentoobservacion" outlined name="input-7-7"
                            label="Observacion del Documento" :readonly="vsdocumentoobservacion == 1"></v-textarea>
                        </v-col>
                      </v-row>

                      <template>
                        <div>
                          <v-col cols="12" md="12" align="center" justify="center">
                            <label>
                              Carga El Documento
                              <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                                v-on:change="handleFileUpload()" />
                            </label>
                          </v-col>
                          <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="secondary" @click="close">Cancelar</v-btn>
                              <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                            </div>
                          </div>

                          <v-card max-width="1200" class="mx-auto">
                            <v-list-item>
                              <v-list-item-avatar color="grey"></v-list-item-avatar>
                              <v-list-item-content align="center" justify="center">
                                <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                              <v-img :src="imagePreview"></v-img>
                            </v-col>

                            <v-col cols="12" md="12" v-if="imagenopdf == 2">
                              <iframe :src="pdfPreview" width="100%" style="height: 80vh;"
                                class="embed-responsive-item"></iframe>
                            </v-col>

                            <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea
                              el
                              Correcto</v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </v-container>
                  </v-form>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="mt-n10 mx-auto">
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


      </v-sheet>
    </v-col>
  </v-row>


</template>





<script>
// Asegúrate de tener 'vue-textarea-autosize' instalado si lo usas
// npm install vue-textarea-autosize
// import TextareaAutosize from 'vue-textarea-autosize';

import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";

export default {
  // components: {
  //   TextareaAutosize // Descomenta si estás usando el componente textarea-autosize
  // },
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
      '4day': '4 Días',
    },
    // Estas propiedades 'start' y 'end' se usarán para el v-model de los input de fecha en el modal
    // y se actualizarán con cadenas ISO en updateRange.
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [
      {
        id: 1,
        name: 'Evento de ejemplo',
        details: 'Descripción del evento',
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        color: '#1976D2',
      }
    ],
    name: null,
    details: null,
    color: '#1976D2',
    dialog: false,
    currentlyEditing: null,
    nextId: 2, // Para simular el ID autoincremental
    documentos: [],
    modaldocumento: 0,
    empresaid: "",
    empresaselect: [],

    fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    modal1: false,
    modal2: false,
    fullPath: "",
    imagenopdf: 0,
    guardarvisible: 0,
    carpetanombre: "", // v-model para tu campo de texto
    carpetaid: 0,
    expedientenombre: "",
    documentofolio: "",
    menu: false,
    show: false,
    menu1: false,
    show1: false,

    documentofechacarga: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    documentofechavence: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
    documentoobservacion: "",
    vsdocumentoobservacion: "",
    eventodetallenombre: "",
    carpetadireccion: "",
    eventodetalleid: "",
    eventoestatus: ""

  }),

  computed: {
    title() {
      const { start, end } = this;
      if (!start || !end) return '';

      // Opciones para toLocaleString
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      // Creamos objetos Date a partir de las cadenas ISO para un formato correcto
      // Añadimos 'T00:00:00' para asegurar que las fechas se interpreten en UTC
      // y evitar posibles desviaciones por la zona horaria local.
      const startDateObj = new Date(start + 'T00:00:00');
      const endDateObj = new Date(end + 'T00:00:00');

      switch (this.type) {
        case 'month':
          // Para el mes, solo necesitamos el mes y el año
          return startDateObj.toLocaleString('es', { month: 'long', year: 'numeric' });
        case 'week':
        case '4day':
          // Para semana y 4 días, mostramos el rango completo
          return `${startDateObj.toLocaleString('es', options)} - ${endDateObj.toLocaleString('es', options)}`;
        case 'day':
          // Para el día, mostramos la fecha completa
          return startDateObj.toLocaleString('es', options);
      }
      return '';
    },
  },

  created() {

    this.listar();
    this.selectempresa();
  },


  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    updateEvent(ev) {
      const index = this.events.findIndex(e => e.id === ev.id);
      if (index !== -1) {
        // Asegúrate de copiar el evento para que Vue detecte el cambio reactivo
        this.events.splice(index, 1, { ...ev });
      }
      this.selectedOpen = false;
      this.currentlyEditing = null;
    },

    getEventTextColor(event) {
      return 'black'; // aquí forzas el texto a negro
    },

    guardardocumento() {

      if (this.file == null) {
        this.$swal("No se a Ingresado el Documento");
        return;
      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };



      let formData = new FormData();
      formData.append("eventodetalleid", me.eventodetalleid);
      formData.append("documentonombre", me.eventodetallenombre);
      formData.append("empresaid", me.empresaid);
      formData.append("carpetaid", me.carpetaid);
      formData.append("documentoruta", me.carpetadireccion);
      formData.append("documentoobservacion", me.documentoobservacion);
      formData.append("documentoruta", me.carpetadireccion);
      formData.append("usuarioid", me.$store.state.usuario.usuarioid);
      formData.append("file0", me.file);
      formData.append("documentofecha", me.documentofechacarga);
      formData.append("documentofechavencimiento", me.documentofechavence);
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "La Fecha es: " + me.documentofechacarga + "<br>"
          + me.documentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/documentos/crear", formData, configuracion)
            .then(function (response) {


              me.$swal("Guardado", "Se a Guardado con Exito", "success");
              me.listar();
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {

                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });






    },

   

    ver(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      // ¡IMPORTANTE! Agrega responseType: 'blob' aquí
      let configuracion = {
        headers: header,
        responseType: 'blob' // Esto le dice a Axios que espere una respuesta binaria
      };

      //alert(item.empresaid)

      axios
        .get("api/eventos/verdocumentotodos/"+item.empresaid+"/"+item.id, configuracion)
        .then(function (response) {
          // La respuesta es un objeto Blob
          const fileBlob = response.data;
          // El tipo de contenido viene en los headers de la respuesta
          const contentType = response.headers['content-type'];

          // Crea un URL de objeto para el Blob. Esto es un URL temporal que el navegador puede usar.
          const blobUrl = URL.createObjectURL(fileBlob);

          // Opción 1: Abrir el documento en una nueva pestaña
          // Esta es la opción más sencilla y robusta para PDFs e imágenes.
          window.open(blobUrl, '_blank');

        })
        .catch(function (error) {
          console.error("Error al obtener el documento:", error);
          // Manejo de errores específicos del backend cuando el archivo no existe
          if (error.response && error.response.data && typeof error.response.data.code !== 'undefined') {
            // Si el backend devuelve JSON de error (cuando el archivo no existe)
            const errorData = JSON.parse(new TextDecoder().decode(error.response.data)); // Decodifica el Blob de error a JSON
            if (errorData.code == 400) {
              me.$swal("La Sesión ha Expirado o el documento no se encontró: " + errorData.message);
              me.$store.dispatch("salir");
            } else {
              me.$swal("Error del servidor: " + errorData.message);
            }
          } else if (error.response) {
            // Otros errores HTTP (ej. 500 del servidor)
            me.$swal("Error al cargar el documento: " + (error.response.statusText || error.response.status));
          } else {
            // Errores de red o de otro tipo
            me.$swal("Error de red o conexión: " + error.message);
          }
        });
    },

    guardar() {


      if (this.carpetadocumentonombre == "") {
        this.$swal("No se a Especificado Nombre de la Carpeta");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "El Nombre de La CARPETA es: " + me.carpetadocumentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/carpetas/crear", {
              carpetanombre: me.carpetadocumentonombre,
              carpetapadre: me.carpetaid,
              carpetaodocumento: 1,
              tipodedocumento: me.tipocomprobanteid,
              empresaid: me.empresaid
            }, configuracion)
            .then(function (response) {
              me.listar1();
              me.TablaVisible = 0;
              me.dialog = false;
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {

                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });







    },

    selectempresa() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/empresas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.empresa;
          listaArray.map(function (x) {
            me.empresaselect.push({
              text: x.empresanombre,
              value: x.empresaid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listar11() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/eventos/listar/"
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.events = response.data.eventodetalle;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    realizado(documento) {

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Realizar El Evento",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/eventos/eventocolor/" + documento.id, {

            }, configuracion)
            .then(function (response) {
              me.listar();
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
              me.selectedOpen = false
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {

                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });







    },

    close() {
      this.modaldocumento = 0;
      this.selectedOpen = false;
    },

    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/eventos/listar", configuracion)
        .then(function (response) {
          me.events = response.data.eventodetalle;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listardocumentoevento(item) {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/eventos/listarexpediente/" + item.id + "/" + item.start
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.documentos = response.data.expedientedetalle;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardar() {
      this.modaldocumento = 1;
    },

    handleFileUpload() {
      /*
          Set the local file variable to what the user has selected.
        */
      this.file = this.$refs.file.files[0];

      /*
          Initialize a File Reader object
        */
      let reader = new FileReader();

      /*
          Add an event listener to the reader that when the file
          has been loaded, we flag the show preview as true and set the
          image to be what was read from the reader.
        */
      reader.addEventListener(
        "load",
        function () {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.extencion = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.imagenopdf = 2;
            this.extencion = 2;
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );



      /*
          Check to see if the file is not empty.
        */
      if (this.file) {
        /*
            Ensure the file is an image file.
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    editEvent(id) {
      this.currentlyEditing = id;
    },
    deleteEvent(ev) {
      this.events = this.events.filter(e => e.id !== ev.id);
      this.selectedOpen = false;
    },
    addEvent() {
      if (this.name && this.start && this.end) {
        const newEvent = {
          id: this.nextId++,
          name: this.name,
          details: this.details,
          start: this.start, // Ya es una cadena ISO gracias al v-model type="date"
          end: this.end,     // Ya es una cadena ISO gracias al v-model type="date"
          color: this.color
        };
        this.events.push(newEvent);
        this.dialog = false;

        // Resetear los campos del formulario
        this.name = null;
        this.details = null;
        this.start = null;
        this.end = null;
        this.color = '#1976D2';
      } else {
        console.warn('Para agregar un evento, los campos de nombre, inicio y fin son obligatorios.');
        // Opcional: podrías mostrar una notificación al usuario aquí
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.empresaid = event.empresaid;
        this.eventodetallenombre = event.eventodetallenombre;
        this.carpetadireccion = event.carpetadireccion;
        this.eventodetalleid = event.id;
        this.eventoestatus = event.eventoestatus;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      // El v-calendar en el evento @change proporciona objetos con year, month, day.
      // Los convertimos a cadenas ISO para que el `computed` 'title' pueda usarlos fácilmente
      // y también para el v-model de los inputs de tipo 'date'.
      this.start = `${start.year}-${String(start.month).padStart(2, '0')}-${String(start.day).padStart(2, '0')}`;
      this.end = `${end.year}-${String(end.month).padStart(2, '0')}-${String(end.day).padStart(2, '0')}`;
    },
    // La función nth ya no es necesaria con el nuevo formato de título
    // nth(d) {
    //   return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd'][d % 10] || 'th'
    // }
  }
}
</script>

<style scoped></style>